import React, { useState } from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import "../../style/style.css";

import { CircularProgress, InputAdornment } from "@mui/material";
import CrossSvg from "../../svg/crossSvg";
import { toast } from "react-toastify";
import axios from "axios";

function EmailContact() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({
    email: "",
    message: "",
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    // Validate email format
    if (name === "email") {
      const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
      if (!emailRegex.test(value)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Please enter a valid email address.",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      }
      setEmail(value);
    }
  };
  const handleChangeTextArea = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (name === "message") {
      if (value === "") {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "please enter the message",
        }));
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      }
      if (message.length <= 500) {
        setMessage(value);
      } else {
        setMessage(message.slice(0, 500)); // Trim excess characters
      }
    }
  };

  const handleClearField = (field: string) => {
    if (field === "message") setMessage("");
    if (field === "email") setEmail("");

    setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
  };
  const Submit = async () => {
    setLoading(true); // Show loader
    try {
      const data = {
        email: email,
        message: message,
      };
      await axios
        .post("https://portal.fitstreak.club/api/api/users/queries", {
          data: data,
        })
        .then((response) => {
          console.log(response.status);
          if (response.status === 201) {
            toast.success("Message sent");
          } else {
            toast.error("Failed to send the message");
          }
        });
    } catch (error) {
      console.error("Error submitting the form:", error);
      toast.error("An error occurred");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="step1 w-[90%] xxs:p-4 p-6 sm:p-10 sm:w-[500px] mt-10 mb-10 md:w-[700px]  rounded-[4px] bg-[#303030] m-auto item-center justify-center   ">
      {loading && (
        <div
          className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10"
          style={{ backdropFilter: "blur(5px)" }}
        >
          <CircularProgress size="3rem" style={{ color: "red" }} />
        </div>
      )}
      <h1 className="md:text-xl text-base text-white font-bold">
        Connect Instantly with Us
      </h1>
      <h1 className="md:text-sm text-sm  mt-4 text-[#bbbbbb] ">
        Share your query or concern with us by filling out the email and message
        box below. Our team is committed to providing you with a prompt and
        helpful response.
      </h1>
      <Box
        component="form"
        sx={{ "& > :not(style)": { mt: 4, width: "90%" } }}
        noValidate
        autoComplete="on"
      >
        <TextField
          id="standard-basic"
          name="email"
          label="Email"
          variant="standard"
          value={email}
          onChange={handleChange}
          error={!!errors.email}
          helperText={errors.email}
          InputProps={{
            endAdornment: errors.email ? (
              <InputAdornment position="end">
                <CrossSvg onClick={() => handleClearField("email")} />{" "}
                {/* Conditionally render CrossSvg */}
              </InputAdornment>
            ) : null,
          }}
        />
      </Box>
      <label
        htmlFor="label"
        className="text-white flex justfy-start item-center w-[90%] m-auto mt-6 font-semibold text-sm"
      >
        Message
      </label>
      <div className="w-[90%] m-auto mt-2 relative">
        <textarea
          onChange={handleChangeTextArea}
          className={`text-white flex justify-start items-center w-full bg-[#3d3d3d] rounded-[6px] p-4 text-sm focus:outline-none ${
            errors.message ? "border border-red" : ""
          }`}
          rows={6}
          name="message"
        ></textarea>
        {errors && (
          <p className="text-red text-sm mt-1 text-left">{errors.message}</p>
        )}
        <div className="absolute bottom-2 right-4 text-gray-400 text-xs">
          {message.length}/500
        </div>
      </div>

      <div className="flex w-full  h-auto   justify-end   ">
        <button
          className={`${
            email === "" || message === ""
              ? "bg-inherite border border-[#4e4e4e]"
              : "bg-red"
          }  py-2 px-6 xxs:text-sm   w-max rounded-[5px] text-white font-bold text-base mt-10`}
          disabled={message === "" || email === ""}
          onClick={Submit}
        >
          Submit
        </button>
      </div>
    </div>
  );
}

export default EmailContact;
